var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgConfigurationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0725 16.579C16.7619 18.1077 13.308 18.962 11.5124 19.709C10.7725 19.979 9.93245 19.879 9.28248 19.469L8.53248 18.719C8.11244 18.069 8.01246 17.239 8.29243 16.489L9.77247 12.499C10.1325 11.529 10.6925 10.669 11.4224 9.92901L16.8624 4.49902L18.8624 2.49902H5.11243C2.43244 2.49902 0.252441 4.67901 0.252441 7.35901V22.889C0.252441 25.569 2.43243 27.749 5.11243 27.749H20.6425C23.3225 27.749 25.5025 25.569 25.5025 22.889V9.13904C24.1994 10.4385 19.4592 15.1906 18.0725 16.579Z",
    fill: "#293A52"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9625 1.03847C25.9124 -0.011521 24.1924 -0.011521 23.1425 1.03847L12.8425 11.3385C11.6385 12.3683 10.7863 15.7851 10.1724 17.1885C10.1024 17.3685 10.1425 17.5784 10.2825 17.7185C10.4318 17.8482 10.6228 17.8942 10.8124 17.8284C12.2443 17.2068 15.6126 16.3662 16.6624 15.1585C16.6624 15.1585 26.9625 4.85848 26.9625 4.85848C28.0086 3.8524 28.0093 2.0446 26.9625 1.03847Z",
    fill: "#293A52"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfigurationIcon);
export default __webpack_public_path__ + "static/media/ConfigurationIcon.b94972509fcb41a3704f2620890f8e03.svg";
export { ForwardRef as ReactComponent };